export const appCopilot = "$bdQSc";
export default {appCopilot};